if (!customElements.get('card-color-swatches')) {
  /**
   *  @class
   *  @function CardColorSwatches
   */
  class CardColorSwatches extends HTMLElement {
    constructor() {
      super();
      this.setupSwatches();

    }
    setupSwatches() {
      this.cardImages = this.parentElement.parentElement.parentElement.querySelectorAll('.card__media img');
      this.actionButton = this.querySelector('.color-swatch--action');
      this.outSwatches = this.querySelectorAll('.color-swatch[data-swatch-out]');
      this.swatches = this.querySelectorAll('.color-swatch');
      this.swatchBackground = this.closest('.card-wrapper').querySelector('.card-color-swatches__background');

      if (this.actionButton)
        this.actionButton.addEventListener('click', this.onActionClick.bind(this));
    }
    onActionClick() {
      if (this.classList.contains('expanded')) {

        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('close-animation');
        })

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('close-animation');
          })
          this.classList.remove('expanded')
        }, 300)
      }
      else {

        this.outSwatches.forEach((swatch) => {
          swatch.classList.add('open-animation');
        })

        setTimeout(() => {
          this.outSwatches.forEach((swatch) => {
            swatch.classList.remove('open-animation');
          })
          this.classList.add('expanded')
        }, 300)
      }
    }
  }

  customElements.define('card-color-swatches', CardColorSwatches)
}